module.exports = __webpack_public_path__ + "static/ling-6c57a9b6e238ac424ed66f30a51ce62b.png";